import { render, staticRenderFns } from "./gre.vue?vue&type=template&id=484826ae&scoped=true"
import script from "./gre.vue?vue&type=script&lang=js"
export * from "./gre.vue?vue&type=script&lang=js"
import style0 from "./gre.vue?vue&type=style&index=0&id=484826ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484826ae",
  null
  
)

export default component.exports